import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@mui/material';

import DragDropCtx from 'components/DragDropCtx';
import { Droppable } from 'react-beautiful-dnd';

import ListItem from './ListItem';

const EventProductsList = ({ products, disabled, handleDeleteRequest, handleEditQuantity, handleDragEnd, handleRedirect }) => {
  if (!products || products.length === 0) return null;

  return (
    <DragDropCtx handleDragEnd={handleDragEnd}>
      <Droppable droppableId={"event-products"}>
        {(provided, snapshot) => (
          <Stack
            spacing={1}
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`${snapshot.isDraggingOver ? "dragging-over" : ""}`}
          >
            {products.map((product, index) => (
              <ListItem
                product={product}
                disabled={disabled}
                handleDeleteRequest={handleDeleteRequest}
                handleEditQuantity={handleEditQuantity}
                handleRedirect={handleRedirect}
                index={index}
                key={product.listing_id} />
            ))}
            {provided.placeholder}
          </Stack>
        )}
      </Droppable>
    </DragDropCtx>
  );
};

EventProductsList.propTypes = {
  products: PropTypes.array,
  disabled: PropTypes.bool,
  handleDeleteRequest: PropTypes.func,
  handleEditQuantity: PropTypes.func,
  handleDragEnd: PropTypes.func,
  handleRedirect: PropTypes.func,
};

export default EventProductsList;
